import { render, staticRenderFns } from "./CtaButton.vue?vue&type=template&id=ca1feaaa&scoped=true&"
import script from "./CtaButton.vue?vue&type=script&lang=js&"
export * from "./CtaButton.vue?vue&type=script&lang=js&"
import style0 from "./CtaButton.vue?vue&type=style&index=0&id=ca1feaaa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca1feaaa",
  null
  
)

export default component.exports